import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import "./styles.css";
import { collection, getDocs, query, where } from "firebase/firestore";
import CardsComponent from "./CardsComponent";
import { useSponsorFeatureFlag } from "@/utils/featureFlags";
import { useFirebaseAuth } from "@/contexts/UserProfileContext/UserProfileContext";
import { getFirestoreDB } from "@/firebase";

interface CardData {
    id: string;
    imageLink: string;
    title: string;
}

function SponsorCard() {
    const [cardsData, setCardsData] = useState<CardData[]>([]);
    const { isEnabled: isFeatureFlagEnabled } = useSponsorFeatureFlag();
    const { userProfile } = useFirebaseAuth();

    const isEnabled = userProfile?.inUserTesting && isFeatureFlagEnabled;

    useEffect(() => {
        const fetchData = async () => {
            const db = getFirestoreDB();
            const collectionRef = collection(db, "trialFinderStudy");
            const userStudiesQuery = query(collectionRef, where("s.isSponsored", "==", true));
            const querySnapshot = await getDocs(userStudiesQuery);
            const data: CardData[] = querySnapshot.docs
                .map((doc) => ({
                    id: doc.get("nctId"),
                    imageLink: doc.get("s.imageLink"),
                    title: doc.get("a.title"),
                }))
                .filter((card) => card.title);

            setCardsData(data);
        };

        if (isEnabled) {
            fetchData();
        }
    }, [isEnabled]);

    // In case we want clickable UP DOWN buttons instead of scroll

    // const cardsPerPage = isMobile ? 1 : 2; // 1 card per page for mobile, 2 for larger screens
    // const handleNext = () => {
    //     if (currentIndex + cardsPerPage < cardsData.length) {
    //         setCurrentIndex(currentIndex + cardsPerPage);
    //     }
    // };

    // const handlePrev = () => {
    //     if (currentIndex - cardsPerPage >= 0) {
    //         setCurrentIndex(currentIndex - cardsPerPage);
    //     }
    // };

    // // Slice the data to get the currently displayed cards
    // const displayedCards = cardsData.slice(
    //     currentIndex,
    //     currentIndex + cardsPerPage
    // );

    if (!isEnabled || cardsData.length === 0) {
        return null;
    }

    return (
        <div className="sponsor-container outer-div">
            <div className="card-box">
                <h2 className="box-heading">
                    Sponsored Studies
                    <br />
                    <i>Not real studies. Example only for user testing.</i>
                </h2>
                <div className="scrollable-container">
                    {/* 80px vertical gutter adjusts for the image's negative margin */}
                    <Row justify="center" gutter={[16, 24]}>
                        {cardsData.map((card) => (
                            <Col key={card.id}>
                                <CardsComponent imageLink={card.imageLink} title={card.title} nctId={card.id} />
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default SponsorCard;
